import LinearProgress from '@mui/material/LinearProgress'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

const TableLoadingBar = ({ colSpan }) => {
  return (
    <TableRow data-testid="loadingbar">
      <TableCell colSpan={colSpan} sx={{ p: 0 }}>
        <LinearProgress />
      </TableCell>
    </TableRow>
  )
}

export default TableLoadingBar
